import React, { Component } from 'react'

class FolderSkeleton extends Component {
  render() {
    return (
        <div className='skeleton-wrapper-folder'>
            <svg className='icon-hgradient' focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                <defs>
                    <linearGradient id="skeletonGradientIcon">
                        <stop offset="0%" stopColor="#edeef1">
                            <animate attributeName="stop-color" values="#edeef1; #f6f7f8; #f6f7f8; #f6f7f8" dur="1s" repeatCount="indefinite"></animate>
                        </stop>
                        <stop offset="20%" stopColor="#f6f7f8">
                            <animate attributeName="stop-color" values="#f6f7f8; #edeef1; #f6f7f8; #f6f7f8" dur="1s" repeatCount="indefinite"></animate>
                        </stop>
                        <stop offset="40%" stopColor="#f6f7f8">
                            <animate attributeName="stop-color" values="#f6f7f8; #f6f7f8; #edeef1; #f6f7f8" dur="1s" repeatCount="indefinite"></animate>
                        </stop>
                        <stop offset="100%" stopColor="#f6f7f8">
                            <animate attributeName="stop-color" values="#f6f7f8; #f6f7f8; #f6f7f8; #edeef1;" dur="1s" repeatCount="indefinite"></animate>
                        </stop>
                    </linearGradient>
                </defs>
                <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"></path>
                <path fill="none" d="M0 0h24v24H0z"></path>
            </svg>
            <div className="skeleton-content-folder"></div>
        </div>
    )
  }
}

export default FolderSkeleton
